// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2JN-I","savePackageButton":"ClientWallet_savePackageButton__jbimT"};